import React, { useEffect, useRef } from 'react';
import 'altcha';
import config from '../../config';

interface AltchaState {
  state: string;
  payload: string;
}

interface AltchaWidgetProps {
  // Called with the solved payload when verified, or '' on reset/expiry.
  onVerified: (payload: string) => void;
}

const CHALLENGE_URL = `${config.SERVER_URL}/auth/altcha-challenge`;

/**
 * ALTCHA fetches a challenge from the
 * backend, solves it in a Web Worker, and hands the base64 payload to the parent
 * to send as the `X-Altcha-Payload` header.
 */
const AltchaWidget = ({ onVerified }: AltchaWidgetProps) => {
  const ref = useRef<HTMLElement>(null);
  // Keep the latest callback without re attaching the listener each render.
  const onVerifiedRef = useRef(onVerified);
  onVerifiedRef.current = onVerified;

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    const handler = (event: Event) => {
      const { state, payload } = (event as CustomEvent<AltchaState>).detail;
      onVerifiedRef.current(state === 'verified' ? payload : '');
    };
    el.addEventListener('statechange', handler);
    return () => el.removeEventListener('statechange', handler);
  }, []);

  // auto="onload" solve captcha automatically when the widget mounts
  return <altcha-widget ref={ref} challengeurl={CHALLENGE_URL} auto="onload" />;
};

export default AltchaWidget;
